/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LastName/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'



/** @type {import('Simple/types.js').View} */
export default function LastName({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/PatientOptions/New/LastName",
  isInvalid,
  onChange
  
}) {
let appointmentOverlayPatientNewPersonLastNameValueData = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'patient_new.person.last_name',
})
let appointmentOverlayPatientNewPersonLastNameIsValidData = fromData.useDataIsValid({ viewPath,
context: 'appointment_overlay',
path: 'patient_new.person.last_name',
validate: fromValidate.name,
required: true,
})
let appointmentOverlayPatientNewPersonLastNameChangeData = fromData.useDataChange({ viewPath,
context: 'appointment_overlay',
path: 'patient_new.person.last_name',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 marginTop={0}
 size="small"
 width={92}
 data="appointment_overlay.patient_new.person.last_name"
 validate="/Data/validate.js name"
 required={true}
 invalid={!appointmentOverlayPatientNewPersonLastNameIsValidData}
 value={appointmentOverlayPatientNewPersonLastNameValueData}
 onChange={appointmentOverlayPatientNewPersonLastNameChangeData}
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 width={68}
 type="text"
 placeholder="Last *"
/>
)}
</TysiaInputContent>
)}
</TysiaInput>
{children}
</React.Fragment>)
}